export default __webpack_public_path__ + "static/media/webird-desktop.b9c4824b.jpg";